module.exports = __webpack_public_path__ + "971a41e6a2f93476bba43fb202503381.png";